<template>
	<div
		class="g-block-body-outline g-block-body-padding"
		:class="{
			'g-block-body-outline--edit': editable,
			'is-active': editable && active,
			'g-block-body-outline--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div
			class="g-block-body-outline__frame"
			:style="{ borderColor: themeColor }"
		>
			<RichTextEditable
				v-if="editable"
				class="g-block-body-outline__text"
				:model-value="data.content"
				placeholder="请输入正文"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-body-outline__text"
				v-html="data.content || ''"
			></div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { getTitleThemeColor } from '../../../templates.js';
	import { bodyMixin } from '../shared/bodyMixin.js';

	export default {
		name: 'GBlockBodyOutline',
		components: { RichTextEditable },
		mixins: [bodyMixin],
		computed: {
			themeColor() {
				return getTitleThemeColor(this.data);
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../shared/bodyEditShell.less';

	.g-block-body-outline {
		.body-block-edit-shell();
	}

	.g-block-body-outline__frame {
		border: 1px solid;
		border-radius: 4px;
		padding: 14px;
		box-sizing: border-box;
	}

	.g-block-body-outline__text {
		.body-text-base();
	}

	.g-block-body-outline--h5 {
		.g-block-body-outline__frame {
			border-radius: 0.08rem;
			padding: 0.28rem;
		}
		.body-text-base--h5(~'.g-block-body-outline__text');
	}
</style>
